import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { GmbRepository } from './reposiitories/gmb.repository';
import { GMB_REPOSITORY } from './reposiitories/IGmb.repository';
import { GmbService } from './services/gmb.service';
import { GMB_SERVICE } from './services/IGmb.service';

interface ModuleOptionsInterface {
  providers: Provider[];
}

@NgModule({
  declarations: [],
  imports: [HttpClientModule],
  exports: [],
})
export class GmbCoreModule {
  static forRoot(
    config?: ModuleOptionsInterface
  ): ModuleWithProviders<GmbCoreModule> {
    return {
      ngModule: GmbCoreModule,
      providers: [
        { provide: GMB_SERVICE, useClass: GmbService },
        {
          provide: GMB_REPOSITORY,
          useClass: GmbRepository,
        },
        ...(config?.providers || []),
      ],
    };
  }
}
